module.exports = __webpack_public_path__ + "47da4f6ff3e81fc20633a14ab7955069.svg";